import React from 'react'
import Box from '@mui/material/Box'

// Helper text rendered beneath an Activity field, driven by two independent signals:
//   - `error` (a validation message) — populated only after a failed submit. MUI already colors
//     the input box + helper text red via the input's `error` prop, so this returns a plain string.
//   - `required` — true from the moment the form loads. We render a red 'Required' hint whose color
//     comes from this span, NOT from the input's `error` prop, so the box stays neutral (no red
//     outline) while the text is red — signalling the field is mandatory without looking like a
//     failure yet.
// Non-required, non-error fields render a single space to reserve the helper-text row (avoids the
// layout shifting when a message later appears).
export const requiredHelperNode = (error?: string, required?: boolean): React.ReactNode => {
    if (error) return error
    if (required)
        return (
            <Box component="span" sx={{ color: 'error.main' }}>
                Required
            </Box>
        )
    return ' '
}

// Convenience wrapper for the common case where required-ness and errors are looked up from the
// org's `requiredFields` list and the form's `fieldErrors` map by document field name.
export const requiredFieldHelperText = (
    field: string,
    requiredFields?: string[],
    fieldErrors?: Record<string, string>
): React.ReactNode => requiredHelperNode(fieldErrors?.[field], requiredFields?.includes(field))
